module.exports = __webpack_public_path__ + "static/media/A-tu-Lado.6d121897.svg";